var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlatbed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 5.76923L20.4578 1.44231M24.75 5.76923V9.80769M24.75 5.76923H20.4578V1.44231M20.4578 1.44231H17.5964M17.5964 1.44231V0M17.5964 1.44231V8.65385M17.5964 8.65385H1L1.57229 11.25H24.75V9.80769M17.5964 8.65385H19.3133L20.4578 9.80769H24.75",
    stroke: "#626262",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.75,
    cy: 12.5,
    r: 2.1,
    strokeWidth: 0.8,
    stroke: "#626262"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 12.5,
    r: 2.1,
    strokeWidth: 0.8,
    stroke: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatbed);
export default __webpack_public_path__ + "static/media/flatbed.212a2330ed57e051376d8f0d91e06948.svg";
export { ForwardRef as ReactComponent };